import * as React from 'react';
import { connect } from 'react-redux';
import SeriesListComponent from './series-list';
import FestivalInfoComponent from './festival-info';
import { FestivalOverviewAppState } from '../classes/redux-states';
import { Series } from '../classes/series';


interface ExternalProps {
    seriesList: Series[];
    dayLabel: string;
}

export class SeriesListContainerComponent extends React.Component<ExternalProps, null> {
    constructor(props: ExternalProps) {
        super(props);
     
    }

    checkSeriesParams() {
        var urlParams = new URLSearchParams(window.location.search);
        let seriesParam = urlParams.get('series');
        if (seriesParam) {
            // Allow breathing room before scroll
            setTimeout(() => {
                const seriesID = document.getElementById(seriesParam);
                if (seriesID) {
                    const seasonsNav = document.querySelector('.season-overview-navigation').clientHeight + 50;
                    const y = seriesID.getBoundingClientRect().top + window.pageYOffset - seasonsNav;
                    window.scrollTo({
                        top: y,
                        behavior: "smooth"
                    });
                }
            }, 1000)
        }
    }

    componentDidMount() {
        this.checkSeriesParams();
    }


    render() {
        return (
            <div>
                <FestivalInfoComponent />

                <SeriesListComponent seriesList={this.props.seriesList} dayLabel={this.props.dayLabel} />

            </div>
        );
    }
}

export default connect(null, null)(SeriesListContainerComponent);
